/**
 * @description 優惠活動內容頁顯示格式用
*/
export enum PromotionInnerType {
    A = '1',
    B = '2',
    C = '3'
}
